// color mobile tooltip
function mobile_color_details_tooltip() {
  var $all_color_variants = $('.custom-bed-option-container[variant_product_variant_name_for_tooltip="color"]');
  $all_color_variants.each(function () {
    $(this).on("click", function () {
      // log("clickeddd");
      var $variant_id = $(this).attr("customizer-variant-id");
      var $all_color_tooltips = $(".boxspringbed-tooltip-mobile2");

      $all_color_tooltips.removeClass("active");
      var full_tooltip_id = "color-tooltip-id-" + $variant_id;

      $all_color_tooltips.each(function () {
        var $color_tooltip = $(this);
        var $color_tooltip_id = $color_tooltip.attr("id");
        if ($color_tooltip_id == full_tooltip_id) {
          $(this).addClass("active");
        }
      });
    });
  });
  $('.boxspringbed-tooltip-mobile-close').on("click", function () {
    var $all_color_tooltips = $(".boxspringbed-tooltip-mobile2");
    $all_color_tooltips.removeClass("active");
  });
}
// end color mobile tooltip

function changeSelectedItemTitle($item) {
  var selected_item_title = $item.attr('customizer-variant-title');
  var selected_item_product_id = parseInt($item.attr('customizer-product-id'));
  var className = "p.customizer-selected-item-title-" + selected_item_product_id + "";

  $(className).text(selected_item_title);
}

function changeSelected_not_customizer_variant($item) {

  log($item);

  var product_options = $item.attr("product-options");
  if (product_options != "1") {
    var option_index = $item.attr("option-index");
    var customizer_product_id = $item.attr('customizer-product-id');
    var allCustomizerVariants = $("div.customizer-option-list[customizer-product-id=" + customizer_product_id + "][option-index=" + option_index + "] .custom-bed-option-container");
    $(allCustomizerVariants).find("input").removeAttr("checked2");
    $(allCustomizerVariants).find("input").removeAttr("checked");
    $item.find("input").attr("checked2", "checked");
  }
  else {
    var customizer_product_id = $item.attr('customizer-product-id');
    var allCustomizerVariants = "div.customizer-option-list[customizer-product-id=" + customizer_product_id + "][product-options='1'] .custom-bed-option-container";
    $(allCustomizerVariants).find("input").removeAttr("checked2");
    $item.find("input").attr("checked2", "checked");
  }


}

function changeSelectedItem($item, remove_it = false) {
  var customizer_product_id = $item.attr('customizer-product-id');
  var allCustomizerVariantsContainer = "div.customizer-option-list[customizer-product-id=" + customizer_product_id + "]";

  // get current selected variant id and place it on customizer container attribute 'current-selected-customizer-id'
  var currentVariantId = $item.attr("customizer-variant-id");
  // $(allCustomizerVariantsContainer).attr("current-selected-customizer-id", currentVariantId)

  var allCustomizerVariants = "div.customizer-option-list[customizer-product-id=" + customizer_product_id + "] .custom-bed-option-container";
  // remove on all from this customizer product attribute checked
  $(allCustomizerVariants).find("input").removeAttr("checked2");
  // set checked on current selected
  if (remove_it) {
    // changeSelectedItemTitle();
  } else {
    $item.find("input").attr("checked2", "checked");
    changeSelectedItemTitle($item);
  }


  var item_id = $item.attr("customizer-variant-id");
  var item_price = $item.attr("customizer-variant-price");
  var item_regular_price = $item.attr("customizer-variant-regular-price");
  var item_title = $item.attr("customizer-variant-title");
  var variant_no_data = $item.find("input").attr("variant_no_data");
  var cart_item_sort = $item.parents(".related-products-wrapper").attr("cart-sort-order");
  // log(cart_item_sort);

  if (item_price) {
    item_price = parseInt(item_price);
  }
  else {
    item_price = 0;
  }

  if (item_regular_price) {
    item_regular_price = parseInt(item_regular_price);
  }
  else {
    item_regular_price = 0;
  }

  var product_quantity = 1;
  if (document.getElementsByClassName('quantity__input')[0]) {
    // product_quantity = parseInt(document.getElementsByClassName('quantity__input')[0].value)
  }

  window.custom_opt = window.custom_opt || {};
  window.custom_opt["customizer_products"] = window.custom_opt["customizer_products"] || [];

  if (variant_no_data == "false" && remove_it == false) {
    var rem = window.custom_opt["customizer_products"].findIndex(a => a.product_id === customizer_product_id);
    if (rem !== -1) {
      var itemToRemove = window.custom_opt["customizer_products"][rem];
      window.custom_opt['price_with_options'] = window.custom_opt['price_with_options'] - itemToRemove.price;
      window.custom_opt["customizer_products"].splice(rem, 1);

      if (itemToRemove.regular_price) {
        var item_diff = itemToRemove.regular_price - itemToRemove.price;
        window.custom_opt['customizer_price_diff'] = window.custom_opt['customizer_price_diff'] - item_diff;
      }
    }

    // add it
    // log("add it " + item_id);
    var customizer_product = {};
    customizer_product.id = item_id;
    customizer_product.product_id = customizer_product_id;
    customizer_product.quantity = product_quantity;
    customizer_product.properties = {};
    customizer_product.cart_item_sort = cart_item_sort;
    customizer_product.price = item_price;
    customizer_product.regular_price = item_regular_price;
    window.custom_opt['price_with_options'] = window.custom_opt['price_with_options'] + item_price;

    if (item_regular_price) {
      window.custom_opt['customizer_price_diff'] = item_regular_price - item_price + window.custom_opt['customizer_price_diff'];
    }

    window.custom_opt["customizer_products"].push(customizer_product);
  }
  else {
    // remove it 
    // log("remove it " + item_id);
    var rem = window.custom_opt["customizer_products"].findIndex(a => a.product_id === customizer_product_id);

    if (rem !== -1) {
      var itemToRemove = window.custom_opt["customizer_products"][rem];
      window.custom_opt['price_with_options'] = window.custom_opt['price_with_options'] - itemToRemove.price;

      window.custom_opt["customizer_products"].splice(rem, 1);

      if (itemToRemove.regular_price) {
        var item_diff = itemToRemove.regular_price - itemToRemove.price;
        window.custom_opt['customizer_price_diff'] = window.custom_opt['customizer_price_diff'] - item_diff;
      }
    }
  }

  if (Math.round((window.custom_opt['price_with_options'] / 100)) == (window.custom_opt['price_with_options'] / 100)) {
    product_price_with_options.innerText = formatPriceWithCurrency((window.custom_opt['price_with_options'] / 100), window.store_currency);
  }
  else {
    product_price_with_options.innerText = formatPriceWithCurrency((window.custom_opt['price_with_options'] / 100).toFixed(2), window.store_currency);
  }

  // log(window.custom_opt["customizer_products"]);
  if (typeof updateRegularPrice == 'function') {
    updateRegularPrice()
  }
}

var get_first_variant_visible = function ($list) {
  var $new_list = $list.filter(function (index) {
    return $(this).css("display") != "none";
  });
  return $new_list.first();
}

// if we have product with more then 1 option
function get_selected_product_variant_id(product_id) {

  var $selected_product_options = $(".related-products-wrapper .custom-bed-options-container input[checked2='checked'][customizer-product-id=" + product_id + "]");
  var selectedOptions = [];
  $selected_product_options.each(function () {
    var val = $(this).attr("value");
    selectedOptions.push(val);
  });

  var main_product = window.custom_opt['main_product'];
  const selectedVariant = main_product.variants.find(variant => {
    // variant.options is usually an array like ["Large", "Red", null]
    return selectedOptions.every((value, i) => {
      return value === variant.options[i];
    });
  });

  var selected_var_id = selectedVariant ? selectedVariant.id : null;
  log(selected_var_id);
  return selected_var_id.toString();
}

function check_not_compatibile() {
  // log("check_not_compatibile");

  var check_again = false;

  var $all_customizer_products = $(".custom-bed-customization-container .customizer-option-list");
  $all_customizer_products.each(function () {
    var $current_product_id = $(this).attr("customizer-product-id");
    var $current_selected_variant = $(this).find("input[checked2='checked']");
    var variant_no_data = $current_selected_variant.attr("variant_no_data");
    if (variant_no_data == "true") {
      return false;
    }

    // product - product
    // loop all products again and check if current product_id is in other product not compatible with product list and hide it.
    var $all_customizer_products2 = $(".custom-bed-customization-container .customizer-option-list");
    var customizer_style = $(this).parents(".related-products-wrapper").css('display');
    if (customizer_style == "flex") {
      $all_customizer_products2.each(function () {
        var product_id = $(this).attr("customizer-product-id");
        if (product_id == "15043461349716") {
          var asd = "123";
        }

        var $product_not_compatible_product_list = $(this).attr("product_not_compatible_with_products");
        var customizer_style2 = $(this).parents(".related-products-wrapper").css('display');
        //check if this product has not compatible product and if there is hide it
        if ($product_not_compatible_product_list && $product_not_compatible_product_list.includes($current_product_id) && customizer_style2 == "flex") {
          // remove checked since we are hidding it
          // set check again to true maybe there is some other not compatibility to show/hide
          var $all_variants_in_this_product = $(this).find(".custom-bed-option-container input");
          if ($all_variants_in_this_product.length) {
            $all_variants_in_this_product.removeAttr("checked2");

            var $first_visible = get_first_variant_visible($all_variants_in_this_product);
            if ($first_visible.length > 0) {
              changeSelectedItem($first_visible);
            }
            else {
              hide_product_customizer($all_variants_in_this_product);
            }
          }
          check_again = true;
          $(this).parents(".related-products-wrapper").attr("style", "display:none");
        }
      });
    }
    // end product - product
  });

  // variant - product
  // for each customizer product check if is selected variant with data and hide variants if are not compatible with current
  var $all_customizer_products2 = $(".custom-bed-customization-container .customizer-option-list");
  $all_customizer_products2.each(function () {
    var $selected_variant_input2 = $(this).find("input[checked2='checked']");
    if ($selected_variant_input2.length) {
      var $selected_product_id2 = $selected_variant_input2.attr("customizer-product-id");

      var $all_customizer_products_variants2 = $(".custom-bed-customization-container .customizer-option-list .custom-bed-option-container");

      $all_customizer_products_variants2.each(function () {
        var $variant_not_compatible_with_products2 = $(this).attr("variant_not_compatible_with_products");
        if ($variant_not_compatible_with_products2.length) {
          if ($variant_not_compatible_with_products2.includes($selected_product_id2)) {
            // select first if we remove the one that is selected at the moment
            var $to_remove_is_checked2 = $(this).find("input").attr("checked2");
            if ($to_remove_is_checked2 == "checked") {
              var $all_variants_in_this_product = $(this).parents(".customizer-option-list").find(".custom-bed-option-container input");
              var $current_list2 = $(this).parents(".customizer-option-list").find(".custom-bed-option-container");
              $all_variants_in_this_product.removeAttr("checked2");
              // changeSelectedItem(get_first_variant_visible($current_list2));

              var $first_visible = get_first_variant_visible($all_variants_in_this_product);
              if ($first_visible.length > 0) {
                changeSelectedItem($first_visible);
              }
              else {
                hide_product_customizer($all_variants_in_this_product);
              }

              // call again to cheeck if there was some no compatibility from before
              // log("variant - product - first not selected call check not compatible again ");
              // check_not_compatibile();
              check_again = true;
            }
            $(this).attr("style", "display:none");
          }
        }
      });
    }
  });

  // product - variant
  var $all_customizer_products3 = $(".custom-bed-customization-container .customizer-option-list");
  $all_customizer_products3.each(function () {
    var $selected_variant_input3 = $(this).find("input[checked2='checked']");
    if ($selected_variant_input3.length) {
      var $selected_variant_3 = $selected_variant_input3.parents(".custom-bed-option-container");
      var $selected_variant_3_id = $selected_variant_3.attr("customizer-variant-id");

      var $all_customizer_products3_1 = $(".custom-bed-customization-container .customizer-option-list");
      $all_customizer_products3_1.each(function () {
        var $product_not_compatible_with_variants = $(this).attr("product_not_compatible_with_variants");
        if ($product_not_compatible_with_variants && $product_not_compatible_with_variants.length) {
          if ($product_not_compatible_with_variants.includes($selected_variant_3_id)) {
            var $to_remove_has_variant_selected_3_1 = $(this).find("input[checked2='checked']");
            // there is variant with data selected
            // log("product - variant " + $selected_variant_3_id);
            if ($to_remove_has_variant_selected_3_1.length) {
              var $all_variants_in_this_product = $(this).find("input");
              $all_variants_in_this_product.removeAttr("checked2");

              var $first_visible = get_first_variant_visible($all_variants_in_this_product);
              if ($first_visible.length > 0) {
                changeSelectedItem($first_visible);
              }
              else {
                hide_product_customizer($all_variants_in_this_product);
              }
              check_again = true;
            }
            // hide current product which is not compatible with some selected variant
            $(this).parents(".related-products-wrapper").attr("style", "display:none");
          }
        }
      });
    }
  });

  log("check_not_compatibile -- variant - variant ");
  // variant - variant
  var $all_customizer_products4 = $(".related-products-wrapper .customizer-option-list");
  $all_customizer_products4.each(function () {
    var $selected_variant_input4 = $(this).find("input[checked2='checked']");
    if ($selected_variant_input4.length) {
      var $selected_variant_4 = $selected_variant_input4.parents(".custom-bed-option-container");
      var $selected_variant_4_id = $selected_variant_4.attr("customizer-variant-id");

      var main_product = $(this).attr("main-product");
      if (main_product == "true") {
        var product_options = $(this).attr("product-options");
        product_options = parseInt(product_options);
        if (product_options > 1) {
          log("product with more options then 1");
          var product_id = $selected_variant_4.attr("customizer-product-id");
          $selected_variant_4_id = get_selected_product_variant_id(product_id);
        }
      }

      var $all_customizer_products_variants4 = $(".custom-bed-customization-container .customizer-option-list .custom-bed-option-container");

      $all_customizer_products_variants4.each(function () {
        var $variant_4_1 = $(this);
        var var_id = $(this).attr("customizer-variant-id");
        if (var_id == "51274764616020" && $selected_variant_4_id == "54010752598356") {
          var test = 111;
        }
        var $variant_not_compatible_with_variant_list = $variant_4_1.attr("variant_not_compatible_with_variants");
        if ($variant_not_compatible_with_variant_list.length) {
          // log($variant_not_compatible_with_variant_list);
          if ($variant_not_compatible_with_variant_list.includes($selected_variant_4_id)) {
            // check if is selected, if is then unselect all and select 1st
            var $is_variant_selected = $(this).find("input[checked2='checked']");
            var $selected_visibility = $($is_variant_selected).parents(".custom-bed-option-container").css("display") == "block";

            if ($is_variant_selected.length && $selected_visibility) {
              var $all_variants_in_this_product = $(this).parents(".customizer-option-list").find(".custom-bed-option-container");
              $all_variants_in_this_product.find("input").removeAttr("checked2");
              // changeSelectedItem($all_variants_in_this_product.first());
              // log("variant - variant");
              var $first_visible = get_first_variant_visible($all_variants_in_this_product);
              if ($first_visible.length > 0) {
                changeSelectedItem($first_visible);
              }
              else {
                hide_product_customizer($all_variants_in_this_product);
              }

              check_again = true;
            }

            // hide it
            $(this).attr("style", "display:none");
          }
        }
      });
    }
  });
  if (check_again) {
    // log("call AGAIN check_not_compatibile()");
    check_again = false;
    check_not_compatibile();
  }

  check_to_hide_product_customizer();
  check_to_select_hidden_customizer();
  unselect_hidden();
}

var hide_product_customizer = function ($all_variants_in_this_product) {
  $all_variants_in_this_product.each(function () {
    changeSelectedItem($(this), true);
  });
}

var unselect_hidden = function () {
  // log("unselect_hidden");
  var $all_customizer_products = $("div.related-products-wrapper");
  var $all_customizer_products = $all_customizer_products.filter(function (index) {
    return $(this).css("display") == "none";
  });
  $all_customizer_products.each(function () {

    var $selected = $(this).find("input[checked2='checked']");
    var selected_id = $selected.attr("customizer-variant-id");
    if (selected_id == "51697444847956") {
      var aaaa = 1;
    }
    if ($selected.length > 0) {
      $selected.removeAttr("checked2");
      var $item = $selected.parents(".custom-bed-option-container");
      // remove selected item
      changeSelectedItem($item, true);
    }
  });
}

// when customizer product was hidden but then show and select 1st item visible
var check_to_select_hidden_customizer = function () {
  // log("check_to_select_hidden_customizer");
  var $all_customizer_products = $("div.related-products-wrapper");
  var $all_customizer_products = $all_customizer_products.filter(function (index) {
    return $(this).css("display") != "none";
  });

  $all_customizer_products.each(function () {
    var $all_variants_int_this_product_customizer_visible = $(this).find(".custom-bed-option-container");
    var $all_variants_int_this_product_customizer_visible = $all_variants_int_this_product_customizer_visible.filter(function (index) {
      return $(this).css("display") != "none";
    });
    var is_there_selected = $all_variants_int_this_product_customizer_visible.find("input[checked2='checked']");
    if (is_there_selected.length == 0) {

      if ($all_variants_int_this_product_customizer_visible.length > 0) {
        var $first = $all_variants_int_this_product_customizer_visible.first();
        if ($first.length) {
          changeSelectedItem($($first));
        }
      }
    }
  });
}

var check_to_hide_product_customizer = function () {
  // i use div so i can exclude product variants which use variant-radios tag
  var $all_customizer_products = $("div.related-products-wrapper");
  $all_customizer_products.each(function () {
    var $all_variants_int_this_product_customizer_visible = $(this).find(".custom-bed-option-container");
    var $all_variants_int_this_product_customizer_visible = $all_variants_int_this_product_customizer_visible.filter(function (index) {
      return $(this).css("display") != "none";
    });
    if ($all_variants_int_this_product_customizer_visible.length == 0) {
      var $product_customizer_to_hide = $(this);
      // log("HIDE this product customizer there are no variants visible");
      // log($product_customizer_to_hide);
      $(this).attr("style", "display:none");
    }
  });
}

var customizer_reset_hidden = function () {
  $(".custom-bed-option-container[customizer-variant-id]").css("display", "flex");
  // $(".custom-bed-customization-container").parents(".related-products-wrapper").attr("style", "display: flex");
  var $all_customizer_products = $(".related-products-wrapper[style='display:none']");
  $all_customizer_products.attr("style", "display: flex");

  if ($all_customizer_products) {
    var $hidden_customizer_variants = $all_customizer_products.find(".custom-bed-option-container");
    changeSelectedItem(get_first_variant_visible($hidden_customizer_variants));
  }
}

var on_customizer_variant_click = function () {
  // log("init product cust js SCRIPT");
  $(".custom-bed-option-container").on("click", function () {
    log("on custom-bed-option-container CLICK");
    var is_customizer_item = $(this).attr("is-customizer");
    if (is_customizer_item == "false") {
      log("changeSelected_not_customizer_variant");
      changeSelected_not_customizer_variant($(this));
    }
    else {
      log("changeSelectedItem");
      changeSelectedItem($(this));
    }

    customizer_reset_hidden();
    check_not_compatibile();

    if (typeof buildProductOptionsText == 'function') {
      buildProductOptionsText()
    }
  });
}

function init_selected() {
  var $all_selected_variants = $(".custom-bed-customization-container .customizer-option-list input[checked2='checked'][variant_no_data='false'][customizer-variant-id]");
  $all_selected_variants.each(function () {
    changeSelectedItem($(this).parents(".custom-bed-option-container"));
  });

}

var init_customizer = function () {

  //func get all selected and call func changeSelectedItem(item) so we can update price
  init_selected();

  check_not_compatibile();
  on_customizer_variant_click();
  mobile_color_details_tooltip();
  if (typeof buildProductOptionsText == 'function') {
    buildProductOptionsText();
  }
}

document.addEventListener('DOMContentLoaded', function () {
  // call it after 100 ms maybe there was auto change on bed size to 90x200
  setTimeout(function () {
    init_customizer();
  }, 100);

});


document.addEventListener('DOMContentLoaded', function () {
  $(".custom-color-label-item.custom-bed-option-container").click(function() {

    var color_translated_text = $(this).find('label').attr("data-color-translated");
    if(color_translated_text){
      log(color_translated_text);
      var $element_p = $("#custom-selected-color-2");
      if($element_p){
        $element_p.text(color_translated_text);
      }
    }
  });
});